export function computeAdaptiveSignal(feedback = []) {
  if (!feedback.length) {
    return {
      recommendation: "Normal monitoring",
      escalateFaster: false,
      sensitivity: 1,
      confidenceBoost: 0,
    };
  }

  const recent = feedback.slice(0, 10);

  const highRiskCount = recent.filter(f => f.risk === "CRITICAL").length;

  const escalateFaster = highRiskCount >= 3;

  const sensitivity =
    1 + Math.min(highRiskCount * 0.08, 0.3);

  const confidenceBoost =
    Math.min(recent.length * 0.02, 0.2);

  return {
    recommendation: escalateFaster
      ? "Increase monitoring frequency"
      : "Normal monitoring",
    escalateFaster,
    sensitivity,
    confidenceBoost,
  };
}
